import type { UserListItem, UserRole } from "@/features/user/types";

export const EDITABLE_USER_ROLES: UserRole[] = [
  "super",
  "admin_helper",
  "checker",
  "client",
  "client_store",
  "supplier",
];

export function editableRolesForActor(
  actor: Pick<UserListItem, "role">,
): UserRole[] {
  if (actor.role === "super") return EDITABLE_USER_ROLES;
  return [];
}

export function canActorEditUserIdentity(
  actor: Pick<UserListItem, "role">,
  target: Pick<UserListItem, "role">,
): boolean {
  return actor.role === "super" && target.role !== "overviewer";
}

export function canActorEditStoreAccess(
  actor: Pick<UserListItem, "id" | "role" | "client_id">,
  target: Pick<UserListItem, "id" | "role" | "client_id">,
): boolean {
  if (target.role !== "client_store") return false;
  if (actor.role === "super") return true;
  return (
    actor.role === "client" &&
    !!actor.client_id &&
    actor.client_id === target.client_id
  );
}

export function generateInitialPassword(random = Math.random): string {
  const upper = "ABCDEFGHJKLMNPQRSTUVWXYZ";
  const lower = "abcdefghijkmnopqrstuvwxyz";
  const digits = "23456789";
  const symbols = "@#$%";

  const pick = (chars: string) =>
    chars[Math.floor(random() * chars.length)] ?? chars[0];

  return [
    pick(upper),
    pick(upper),
    pick(lower),
    pick(symbols),
    pick(lower),
    pick(lower),
    pick(digits),
    pick(digits),
  ].join("");
}

export function hasActiveSupplierUser(
  supplierId: string,
  users: UserListItem[],
): boolean {
  return users.some(
    (user) =>
      user.role === "supplier" &&
      !user.deactivated_at &&
      user.supplier_id === supplierId,
  );
}
